import { Component, createRef } from "react";
import { NSALayout, NSALayoutCustomProps } from "namirasoft-account-react";
import { NSMenuActionProps } from "namirasoft-site-react";
import { PasswordMenus } from "./PasswordMenus";

export type PasswordLayoutProps<RowType extends { id: string } = any, RowTypeInput = RowType> =
    NSALayoutCustomProps<RowType, RowTypeInput> & { showDownloadExtension?: boolean };

export class PasswordLayout<RowType extends { id: string } = any, RowTypeInput = RowType> extends Component<PasswordLayoutProps<RowType, RowTypeInput>>
{
    NSALayout_Ref = createRef<NSALayout<RowType, RowTypeInput>>();

    override render()
    {
        const { showDownloadExtension, ...rest } = this.props;
        const extraMenus: { [group: string]: NSMenuActionProps[] } = {
            "Password": PasswordMenus.passwordGroup(this.props),
        };
        if (showDownloadExtension)
            extraMenus["Store"] = [PasswordMenus.download()];

        return (
            <NSALayout
                {...rest}
                ref={this.NSALayout_Ref}
                action={{
                    ...this.props.action,
                    menus: { ...extraMenus, ...this.props.action?.menus }
                }}
            >
                {this.props.children}
            </NSALayout>
        )
    }
}